import { render, staticRenderFns } from "./categoryStatusStatistics.vue?vue&type=template&id=067b83fa"
import script from "./categoryStatusStatistics.vue?vue&type=script&lang=js"
export * from "./categoryStatusStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports